export const notificationTypes = {
  UNSTABLE_CONNECTION: {
    CODE: '222001',
    LIFETIME: Infinity
  },
  WIN_LIMIT_EXCEEDED: {
    CODE: '222002',
    LIFETIME: 30000
  },
};
